var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* CSS */
var bold = 'font-weight: bold';
export var titleBadgeStyle = "background-color: #abe9b2; color: black; border-radius: 2px; ".concat(bold);
export var titleTextStyle = "".concat(bold);
export var rowBadgeStyle = "color: #cfc167; ".concat(bold);
/**
 * @param {Operation} operation
 * @returns
 */
export var messageRow = function (operation) {
    var message = operation.getContext().message;
    if (!message && typeof message !== 'string') {
        return [];
    }
    return [
        "%cMessage :%c ".concat(message),
        rowBadgeStyle, '',
    ];
};
/**
 * @param {*} Operation
 * @returns
 */
export var variablesRow = function (_a) {
    var variables = _a.variables;
    if (!Object.keys(variables).length) {
        return [];
    }
    var content = JSON.stringify(variables, null, 1);
    return [
        "%cVariables :%c ".concat(content),
        rowBadgeStyle, '',
    ];
};
/**
 * @description takes information about the included fragments in the request and formats them
 * @param {Operation} operation
 */
export var fragmentRow = function (_a) {
    var definitions = _a.query.definitions;
    var II = definitions.reduce(function (acc, item) {
        var isFragementType = item.kind === 'FragmentDefinition';
        if (isFragementType) {
            return __spreadArray(__spreadArray([], acc, true), [item.name.value], false);
        }
        return acc;
    }, []);
    if (!II.length) {
        return [];
    }
    var text = II.length > 1 ? 'Includes fragments :' : 'Includes fragment :';
    var fragmentsNames = II.join(', ');
    return [
        "%c".concat(text, " %c").concat(fragmentsNames),
        rowBadgeStyle, '',
    ];
};
/**
 * @description takes the value of operation type and operationName and formats them
 * @param {Operation} operation
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var operationRow = function (_a) {
    var _b = _a.query.definitions, definitions = _b === void 0 ? [] : _b, operationName = _a.operationName;
    var definition = definitions.find(function (_a) {
        var kind = _a.kind;
        return kind === 'OperationDefinition';
    });
    var operationType = definition.operation || 'unknown';
    return [
        "%c ".concat(operationType.toUpperCase(), " %c ").concat(operationName),
        titleBadgeStyle, titleTextStyle,
    ];
};
//# sourceMappingURL=index.js.map